import isIterable from './is-iterable.js';
import isArrayLike from './is-array-like.js';

/** @param {any} obj */
export default (obj) => (isIterable(obj) || isArrayLike(obj) ? Array.from(obj) : [obj]);
